<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        v-for="(item, index) in levelList"
        :key="item.path || index"
      >
        <span class="no-redirect">{{ item.meta?.name }}</span>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import pathToRegexp from "path-to-regexp";

const route = useRoute();
const router = useRouter();
const levelList = ref([]);

// 判断是否首页
const isDashboard = (route) => {
  const name = route?.name;
  if (!name) return false;
  return name.toString().trim().toLowerCase() === "dashboard";
};

// 生成 breadcrumb
const getBreadcrumb = () => {
  let matched = route.matched.filter((item) => item.meta && item.name);

  const first = matched[0];

  levelList.value = matched.filter(
    (item) => item.meta?.name && item.name !== false
  );
};

// 路由变化时更新
watch(
  () => route.fullPath,
  () => {
    getBreadcrumb();
  }
);

// 初始化
onMounted(() => {
  getBreadcrumb();
});

// 跳转链接（保持原逻辑，可选是否使用）
const pathCompile = (path) => {
  const { params } = route;
  const toPath = pathToRegexp.compile(path);
  return toPath(params);
};

const handleLink = (item) => {
  const { redirect, path } = item;
  if (redirect) {
    router.push(redirect);
    return;
  }
  router.push(pathCompile(path));
};
</script>

<style scoped lang="less">
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #f3f3f3;
    cursor: text;
  }
}
</style>
